module.exports = __webpack_public_path__ + "img/mbanner_camera.81655982.png";